/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * API For public part of application: Inzerce movitého majetku
 * This API provides endpoints for public part: Inzerce movitého majetku
 * OpenAPI spec version: v1
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";

import type { AssetIFrameCategoryDtoPaginatedCollection } from "../aPIForPublicPartOfApplicationInzerceMovitéhoMajetku.schemas";

import { restAxiosFetcher } from "../../restAxiosFetcher";
import type { ErrorType } from "../../restAxiosFetcher";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Retrieves all asset categories without pagination.
 */
export const getApiAssetcategories = (options?: SecondParameter<typeof restAxiosFetcher>, signal?: AbortSignal) => {
	return restAxiosFetcher<AssetIFrameCategoryDtoPaginatedCollection>(
		{ url: `/api/assetcategories`, method: "GET", signal },
		options,
	);
};

export const getGetApiAssetcategoriesQueryKey = () => {
	return [`/api/assetcategories`] as const;
};

export const getGetApiAssetcategoriesQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetcategories>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetcategories>>, TError, TData>>;
	request?: SecondParameter<typeof restAxiosFetcher>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetcategoriesQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetcategories>>> = ({ signal }) =>
		getApiAssetcategories(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetcategories>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetcategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAssetcategories>>>;
export type GetApiAssetcategoriesQueryError = ErrorType<unknown>;

export function useGetApiAssetcategories<
	TData = Awaited<ReturnType<typeof getApiAssetcategories>>,
	TError = ErrorType<unknown>,
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetcategories>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetcategories>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetcategories>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetcategories<
	TData = Awaited<ReturnType<typeof getApiAssetcategories>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetcategories>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getApiAssetcategories>>,
					TError,
					Awaited<ReturnType<typeof getApiAssetcategories>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetcategories<
	TData = Awaited<ReturnType<typeof getApiAssetcategories>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetcategories>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves all asset categories without pagination.
 */

export function useGetApiAssetcategories<
	TData = Awaited<ReturnType<typeof getApiAssetcategories>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetcategories>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetcategoriesQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * @summary Retrieves all asset categories without pagination.
 */
export const prefetchGetApiAssetcategoriesQuery = async <
	TData = Awaited<ReturnType<typeof getApiAssetcategories>>,
	TError = ErrorType<unknown>,
>(
	queryClient: QueryClient,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAssetcategories>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
): Promise<QueryClient> => {
	const queryOptions = getGetApiAssetcategoriesQueryOptions(options);

	await queryClient.prefetchQuery(queryOptions);

	return queryClient;
};

export const getGetApiAssetcategoriesSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getApiAssetcategories>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetcategories>>, TError, TData>>;
	request?: SecondParameter<typeof restAxiosFetcher>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiAssetcategoriesQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAssetcategories>>> = ({ signal }) =>
		getApiAssetcategories(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getApiAssetcategories>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAssetcategoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAssetcategories>>>;
export type GetApiAssetcategoriesSuspenseQueryError = ErrorType<unknown>;

export function useGetApiAssetcategoriesSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetcategories>>,
	TError = ErrorType<unknown>,
>(
	options: {
		query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetcategories>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetcategoriesSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetcategories>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetcategories>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAssetcategoriesSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetcategories>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetcategories>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves all asset categories without pagination.
 */

export function useGetApiAssetcategoriesSuspense<
	TData = Awaited<ReturnType<typeof getApiAssetcategories>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiAssetcategories>>, TError, TData>>;
		request?: SecondParameter<typeof restAxiosFetcher>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetApiAssetcategoriesSuspenseQueryOptions(options);

	const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}
